import { Injectable } from '@angular/core';

@Injectable()
export class SampleService {

    constructor() {} 
 
    go(): string {
        return 'Hey HO!';
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/sample.service.ts